import { render } from "./ModalNewTicket.vue?vue&type=template&id=7d004615&scoped=true"
import script from "./ModalNewTicket.vue?vue&type=script&lang=js"
export * from "./ModalNewTicket.vue?vue&type=script&lang=js"

import "./ModalNewTicket.vue?vue&type=style&index=0&id=7d004615&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d004615"]])

export default __exports__